import * as React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "components/bootstrap";
import { Icon } from "components/common";
import usePermissions from "hooks/usePermissions";
const CreateHealthAlertButton = ({ onClick }) => {
  const { t } = useTranslation("enterprise_license");
  const { isPermitted } = usePermissions();
  if (!isPermitted("eventdefinitions:create")) return null;
  return /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", bsSize: "small", onClick }, /* @__PURE__ */ React.createElement(Icon, { name: "notifications" }), " ", t("health.alert.create_alert"));
};
export default CreateHealthAlertButton;
